<template>
    <div class="printManagementDialog">
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="900px">
            <div class="dialogContent">
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
                    <el-form-item label="服务名称" prop="name">
                        <el-input v-model="form.name" placeholder="请输入服务名称"></el-input>
                    </el-form-item>
                    <el-form-item label="图片" prop="imgFile">
                        <div style="display: flex;">
                            <uploadFile
                                :img-file="form.imgFile"
                                @avatarChange="avatarChange($event)"
                                @getDragImgFile="getDragImgFile($event)"
                                @deleteImg="deleteImg($event)"
                            ></uploadFile>
                        </div>
                    </el-form-item>
                    <el-form-item label="服务行业" prop="processType">
                        <el-checkbox-group v-model="form.processType">
                            <el-checkbox v-for="(item,index) in processTypeList" :key="index" :label="item.name"
                                         :name="item.name"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="材料类型" prop="materialType">
                        <el-checkbox-group v-model="form.materialType">
                            <el-checkbox v-for="(item,index) in materialTypeList" :key="index" :label="item.name"
                                         :name="item.name"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="服务价格" prop="price">
                        <el-input v-model="form.price" placeholder="请输入服务价格" style="width: 200px;"></el-input>
                        <span style="padding-left: 10px;">元/克</span>
                    </el-form-item>
                    <el-form-item prop="sort" label="排序">
                        <el-input-number v-model="form.sort" :min="1"></el-input-number>
                    </el-form-item>
                    <el-form-item prop="details" label="服务详情" class="detailsClass">
                        <tinymce v-model="form.details" @input="editInput"></tinymce>
                    </el-form-item>
                    <el-form-item class="submitButtonClass">
                        <el-button type="primary" @click="submit">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import uploadFile from '@/components/uploadFile'
    import tinymce from '@/components/tinymce'
    export default {
        name: "materialManagementDialog",
        data() {
            return {
                dialogVisible: false,
                title: '',
                form: {
                    name: '',
                    processType: [],
                    materialType: [],
                    price: '',
                    sort: '1',
                    details: '',
                    imgFile: []
                },
                rules: {
                    name: [
                        {required: true, message: '请输入服务名称', trigger: 'blur'}
                    ],
                    processType: [
                        {required: true, message: '请选择服务行业', trigger: 'change'}
                    ],
                    materialType: [
                        {required: true, message: '请选择材料类型', trigger: 'change'}
                    ],
                    imgFile: [
                        {required: true, message: '请上传图片'}
                    ],
                    price:[
                        {required: true, validator: this.validatorNum,trigger: 'blur'}
                    ],
                    sort: [
                        {required: true, message: '请设置排序',trigger: 'change'}
                    ],
                    details: [
                        {required: true, message: '请输入服务详情', trigger: 'blur'}
                    ]
                },
                materialTypeList: [
                    {
                        name: '高分子材料'
                    },
                    {
                        name: '金属'
                    },
                    {
                        name: '无机非金属'
                    }
                ],
                processTypeList: [
                    {
                        name: 'FDM'
                    },
                    {
                        name: 'SLS'
                    },
                    {
                        name: 'SLA'
                    },
                    {
                        name: 'SLM'
                    },
                    {
                        name: '3DP'
                    },
                    {
                        name: 'DLP'
                    }
                ]
            }
        },
        components: {
            tinymce,
            uploadFile
        },
        methods: {
            init(type) {
                this.dialogVisible = true
                if(this.$refs.ruleForm){
                    this.$refs.ruleForm.resetFields()
                }
                if (type === 'add') {
                    this.title = '新增'
                } else {
                    this.title = '编辑'
                }
            },
            submit(){
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        alert('submit!');
                    } else {
                        return false;
                    }
                });
            },
            // 表单数字校验
            validatorNum(rule, value, callback){
                if (value === '') {
                    callback(new Error('请输入服务价格'))
                } else if (!/^\d+(\.\d+)?$/.test(value)) {
                    callback(new Error('请输入数字'))
                } else {
                    callback()
                }
            },
            // 编辑器内容更新
            editInput(val){
                this.$refs.ruleForm.validateField('details')
            },
            // 上传成功
            avatarChange(val) {
                this.form.imgFile = val
                this.$refs.ruleForm.validateField('imgFile')
            },
            // 删除图片
            deleteImg(val) {
                this.form.imgFile = val
                this.$refs.ruleForm.validateField('imgFile')
            },
            // 获取拖拽后的图片
            getDragImgFile(file) {
                if (file) {
                    this.form.imgFile = file
                    this.$refs.ruleForm.validateField('imgFile')
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .dialogContent {
        padding: 0 5%;
        /deep/.el-upload-list--picture-card .el-upload-list__item{
            width: 80px;
            height: 80px;
        }
        /deep/.el-upload--picture-card{
            width: 80px;
            height: 80px;
            line-height: 80px;
        }
        /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail{
            width: 80px;
            height: 80px;
        }
        .thumbnailClass{
            width: 80px;
            height: 80px;
            margin-right: 20px;
            .avatar{
                width: 80px;
                height: 80px;
                border: 1px dashed #ddd;
                border-radius: 4px;
                line-height: 80px;
                font-size: 24px;
            }
        }
        .endPeriodClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
            }
        }
        .submitButtonClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
                text-align: center;
                button{
                    padding: 0;
                    width: 120px;
                    height: 35px;
                    line-height: 35px;
                    border-radius: 6px;
                }
            }
        }
        .detailsClass{
            /*/deep/.el-form-item__label{*/
                /*float: none;*/
            /*}*/
            /*/deep/.el-form-item__content{*/
                /*margin-left: 0 !important;*/
            /*}*/
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/commodity/printManagement/serviceCapabilityDialog.vue